@if (hasRegisterBlatt() && verfahrenId !== undefined) {
	<a class="aktenzeichen"
	   data-test-id="aktenzeichen-link"
	   tabindex="0"
	   (click)="openRegisterblatt($event)"
	   (keydown.enter)="openRegisterblatt($event)"
	>{{ renderer.render(aktenzeichen) }}</a>
} @else {
	<span class="aktenzeichen" data-test-id="aktenzeichen">{{ renderer.render(aktenzeichen) }}</span>
}
